import Image from "@/components/Image";
import clsx from "clsx";
import { motion } from "motion/react";
import { useRef } from "react";
import { useDockHoverAnimation } from "./hook";
import type { MenuType } from "./type";

interface Props {
  item: MenuType;
  activeItem?: MenuType;
  mouseX: any;
  className?: string;
  onSelect: (item?: MenuType) => void;
}

export function MenuItem(props: Props) {
  const { item, mouseX, className, activeItem } = props;
  const imgRef = useRef<HTMLImageElement>(null);
  const { width } = useDockHoverAnimation(mouseX, imgRef);

  return (
    <button
      type="button"
      className={clsx(
        "flex items-center h-full w-auto transition-all duration-200 ease-in origin-bottom flex-col justify-end relative group px-2 z-20",
        className
      )}
      data-action={item.dataAction}
      onMouseMove={(event) => {
        mouseX.set(event.nativeEvent.x);
      }}
      onMouseLeave={() => mouseX.set(null)}
      onClick={() => {
        props.onSelect(item);
      }}
    >
      {item.type === "divider" ? (
        <div className="flex items-center justify-center min-h-[56px]">
          <div className={clsx("w-[1px] h-10 rounded-full bg-[#D1D4DC]")} />
        </div>
      ) : (
        <>
          <div
            className="bg-[#FFF]/50 py-1 px-3 rounded-md text-[#1c1c1c] justify-center hidden -top-10 group-hover:flex absolute truncate cursor-pointer"
            style={{
              backdropFilter: "blur(5px)",
            }}
          >
            {item.label}
          </div>
          <motion.div
            ref={imgRef}
            style={{
              width,
              zIndex: 99,
              willChange: "width",
              position: "relative",
            }}
          >
            <Image
              alt={item.label}
              src={
                activeItem?.key === item.key
                  ? activeItem?.activeImg || item.img
                  : item.img
              }
            />
          </motion.div>

          {/* <div
              className={clsx("w-1 h-1 m-0 rounded-[50%] bg-white z-30", {
                "opacity-0": !listDock[item].show,
                "opacity-1": listDock[item].show,
              })}
            /> */}
        </>
      )}
    </button>
  );
}
